export default "__VITE_ASSET__2ef26f9e__"